import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { map } from 'rxjs'
import { wirktAlsLeistungserbringer } from '../services/employee-rollen.util'
import { EmployeeService } from '../services/employee.service'

export const leistungserbringerGuard: CanActivateFn = () => {
  const employeeService = inject(EmployeeService)
  return employeeService.currentlyLoggedInEmployee$.pipe(map((employee) => wirktAlsLeistungserbringer(employee.roles)))
}

/**
 * Sperrt eine Route auf SaniUp-Mitarbeitende — die Routen-Seite desselben Flags, mit dem die
 * Oberfläche noch nicht freigegebene Features ausblendet (`EmployeeService.isSaniupEmployee`).
 *
 * **Ohne diesen Guard reicht das Ausblenden nicht:** eine Seite, die nur aus der Navigation
 * verschwunden ist, bleibt über ihre URL erreichbar — per Lesezeichen, aus einer Mail oder schlicht
 * geraten. Für ein Feature, das produktiv noch nicht existieren soll, ist das eine offene Tür.
 *
 * Bewusst über `currentlyLoggedInEmployee$` statt über das gleichnamige Signal: beim Direkteinstieg
 * über die URL läuft die Abfrage noch, das Signal stünde dann auf `false` und der Guard wiese auch
 * SaniUp-Mitarbeitende ab.
 */
export const saniupEmployeeGuard: CanActivateFn = () => {
  const employeeService = inject(EmployeeService)
  const router = inject(Router)
  return employeeService.currentlyLoggedInEmployee$.pipe(
    map((employee) => employee.email?.endsWith('@saniup.de') ?? false),
    // Kein stiller Abbruch: ohne Umleitung bliebe die alte Seite stehen und der Klick sähe aus, als
    // wäre die Anwendung hängengeblieben.
    map((erlaubt) => erlaubt || router.createUrlTree(['/', 'landing'])),
  )
}
export const externalPartnerGuard: CanActivateFn = () => {
  const employeeService = inject(EmployeeService)
  return employeeService.currentlyLoggedInEmployee$.pipe(map((employee) => employee.roles.includes('EXTERNAL_PARTNER')))
}
